module.exports = __webpack_public_path__ + "img/Larry Beale.43ada29a.jpg";